// extracted by mini-css-extract-plugin
export default {"container":"Reviews_container__WWaGR","content":"Reviews_content__sizXh","row":"Reviews_row__UEiG1","break":"Reviews_break__ns+pg","button":"Reviews_button__FkUUI"};